import { api, setConfig, UPDATE_REPORT_MESSAGE } from '../..';
import { mapEntityToApi } from './mapper';
import { PropertyType } from '../../../common';

export const saveUserReports = (data: PropertyType): Promise<string | void> =>
	api.post('/user/assign-mail-reports', mapEntityToApi(data), setConfig(data)).then(() => {
		return UPDATE_REPORT_MESSAGE;
	});
